import { z } from 'zod'

// Backend update mutation accepts: code, email, firstName, lastName, phone,
// used, usedAt, boughtAt, validUntil, ticketNumber, priceId.
// Form fields below match those args. F5 deviation: used is boolean (no status enum).
export const ticketEditSchema = z.object({
    code: z.string().min(1, 'Povinné pole'),
    email: z.string().email('Neplatný e-mail').optional().or(z.literal('')),
    firstName: z.string().optional().or(z.literal('')),
    lastName: z.string().optional().or(z.literal('')),
    phone: z.string().optional().or(z.literal('')),
    used: z.boolean(),
    // Datetime fields accept null (BDateTimeInput emits null on Vymazat),
    // empty string (initial state from form values), or a parsable date string.
    usedAt: z.string().nullable().optional().or(z.literal('')),
    boughtAt: z.string().nullable().optional().or(z.literal('')),
    validUntil: z.string().nullable().optional().or(z.literal('')),
    ticketNumber: z.string().optional().or(z.literal(''))
})

export type TicketEditInput = z.infer<typeof ticketEditSchema>
